import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FireDataService } from './fire-data.service';
import { DatabaseService } from '../database.service';
import { FireLogFormComponent } from '../fire-log-form/fire-log-form.component';
import { DeleteLogComponent } from '../delete-log/delete-log.component';
import { faShieldAlt } from '@fortawesome/fontawesome-pro-solid';

import { Fire } from '../fire';
import { Site } from '../site';
import { ThrowStmt } from '@angular/compiler';

export interface DialogData {
  fire: Fire;
}

@Component({
  selector: 'app-fire-log',
  templateUrl: './fire-log.component.html',
  styleUrls: ['./fire-log.component.scss']
})
export class FireLogComponent implements OnInit {
  faShieldAlt = faShieldAlt;

  whoami;
  mySiteList;
  fires: Fire[] = [];
  fire: Fire;
  siteList: Site[];
  row: number;
  columnDefs = [];
  defaultColDef;
  rowSelection;
  sitecode;
  excelFile;
  private gridApi;
  private gridColumnApi;
  reportNumbers: number[] = []

  constructor(private fireDataService: FireDataService,
              private databaseService: DatabaseService,
              public dialog: MatDialog) {

    this.defaultColDef = { resizable: true, sortable: true, filter: true };
    this.rowSelection = 'single';

    this.columnDefs = [
      {headerName: 'Agency', field: 'AGENCY_NAME', width: 90, suppressSizeToFit: true},
      {headerName: 'Report #', field: 'REPORT_NUMBER', width: 100, suppressSizeToFit: true},
      {headerName: 'Rpt Date', field: 'REPORT_DATE_PRETTY'},
      {headerName: 'Log Date', field: 'LOG_DATE', width: 90, suppressSizeToFit: true},
      {headerName: 'Type', field: 'FIRE_TYPE', width: 200, suppressSizeToFit: true},
      {headerName: 'Cause of Fire', field: 'FIRE_CAUSE'},
      {headerName: 'Date/Time of Fire', field: 'FIRE_DATE_PRETTY'},
      {headerName: 'Campus', field: 'SITE_NAME'},
      {headerName: 'Location', field: 'LOCATION'},
      {headerName: '# Injuries', field: 'INJURY_COUNT'},
      {headerName: '# Deaths', field: 'DEATH_COUNT'},
      {headerName: 'Est Property Damage', field: 'PROPERTY_DAMAGE'}
    ];
  }

  ngOnInit() {
    if(window.location.pathname.indexOf('/clery/') == -1){
      this.databaseService.getWhoAmI().subscribe(whoami => this.whoami = whoami);
      this.loadSites();
    }
    else{
      this.loadData60()
    }

  }

  onSelectionChanged(event) {
    const selectedRows = this.gridApi.getSelectedRows();
    if (window.location.pathname.indexOf('/clery/') == -1 && this.checkPermissions()) {
      this.openEditLog(selectedRows[0]);
    }// end if
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  checkPermissions(): boolean {
    return this.whoami?.ROLES.some((e: string) => e === 'FIRE');
  }


  getExcel(): void {
    console.log('getting excel files');
    this.databaseService.getExcel(this.fires)
    .subscribe(excelFile => {
      this.excelFile = excelFile;
      window.open('/reports/' + this.excelFile.filename);
    });
  }


  loadData(reload: boolean): void {
    if(reload){
      this.row = 999999999999;
      this.fires = [];
      this.gridApi.setRowData([]);
    }
    this.fireDataService.getFires(this.row).subscribe(fires => {
        if(fires.length > 0 && this.row != fires[fires.length -1].ID){
                this.row = fires[fires.length -1].ID;
                this.gridApi.applyTransaction({add: fires});
                this.gridApi.sizeColumnsToFit();
                this.fires = this.fires.concat(fires);
                this.loadData(false);
            }
      });
  } //end loadData


  loadData60(): void {
    this.fireDataService.getFires(0).subscribe(fires => {
          this.gridApi.applyTransaction({add: fires});
          this.gridApi.sizeColumnsToFit();
          this.fireDataService.getFiresAll().subscribe(fires => this.fires = fires);
      });
  } //end loadData60

  loadSites(): void {
    this.fireDataService.getSites()
    .subscribe(data => {
        this.siteList = data;
        this.loadData(true);
      }
    );
  }

  openAddLog(): void {
    if(this.reportNumbers.length == 0) this.genReportNumArray()
    const dialogRef = this.dialog.open(FireLogFormComponent, {
      width: '600px',
      data: {siteList: this.siteList,  reportNumbers: this.reportNumbers}
    });
    dialogRef.componentInstance.sitecode = this.sitecode;
    dialogRef.componentInstance.reportNumbers = this.reportNumbers;

    dialogRef.afterClosed().subscribe(result => {
      this.loadData(true);
    });
  }// end openAddLog

  openDeleteLog(): void {
    const dialogRef = this.dialog.open(DeleteLogComponent, {
      width: '600px',
      data: {}
    });

    dialogRef.componentInstance.sitecode = this.sitecode;
    dialogRef.componentInstance.type = 'fire';

    dialogRef.afterClosed().subscribe(result => {
      this.loadData(true);
    });
  }// end openDeleteLog

  openEditLog(data): void {
    const dialogRef = this.dialog.open(FireLogFormComponent, {
      width: '600px',
      data: {siteList: this.siteList}
    });
    dialogRef.componentInstance.fire = data;
    dialogRef.componentInstance.sitecode = this.sitecode;

    dialogRef.afterClosed().subscribe(result => {
      this.loadData(true);
    });
  }// end openEditLog

  genReportNumArray(){
    this.fires.map(e =>{
      this.reportNumbers.push(e.REPORT_NUMBER)
    })
  }//End genReportNumArray
}
